import { render } from "./ComplianceAlertsForm.vue?vue&type=template&id=051eccd3&scoped=true"
import script from "./ComplianceAlertsForm.vue?vue&type=script&lang=js"
export * from "./ComplianceAlertsForm.vue?vue&type=script&lang=js"

import "./ComplianceAlertsForm.vue?vue&type=style&index=0&id=051eccd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051eccd3"]])

export default __exports__